import * as Config from '../../../config';
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import useGetBasic from '../../../hooks/useGetBasic';
import { setUser } from "../../../actions/index";
import ListSection from './ListSection';

function ConnectedListSectionManager({
  items, style,
  api, user, isConnected,
  setUser, storeRoute
}) {
  const storeMyGenres = useGetBasic(isConnected ? `/v4/my/genres/?per_page=50` : null);

  const setHistory = useCallback((to) => () => {
    storeRoute.goTo(to);
  }, [storeRoute])

  const isSelected = useCallback((slug) => {
    const [,,slugSelected] = window.location.pathname.split('/');
    return (slugSelected === slug);
  }, [])

  const isFavorite = (id) => (user && user.genres) ? (user.genres.findIndex(x => x.id === id) >= 0) : false;
  
  const setMyGenres = (id, name) => () => {
    const index = storeMyGenres.items.findIndex(x => x.id === id);
    if (index >= 0) {
      const newGenres = [...storeMyGenres.items];
      const removed = newGenres.splice(index, 1);
      storeMyGenres.setItems([...newGenres]);
      setUser({ ...user, genres_ids: [...newGenres].map(x => x.id), genres: [...newGenres].map(x => ({id: x.id, name: x.name})) });
      api.del(`/v4/my/genres/${removed[0].id}`);
    } else {
      storeMyGenres.setItems([...storeMyGenres.items, { id, name }]);
      setUser({ ...user, genres_ids: [...storeMyGenres.items, { id }].map(x => x.id), genres: [...storeMyGenres.items, { id, name }].map(x => ({id: x.id, name: x.name})) });
      api.post(`/v4/my/genres/`, {id});
    }
  }

  const hasFavorites = (x) => (isFavorite(x.id) && isConnected);
  const electronic = (x) => ((!isFavorite(x.id) || !isConnected) && (x.category && x.category.id === 1));
  const openFormat = (x) => ((!isFavorite(x.id) || !isConnected) && (x.category && x.category.id === 2));

  useEffect(() => {
    if (window.location.pathname === `/genres` && items && isConnected && user) {
      const first = items.filter((item) => (user && user.genres && (user.genres.findIndex(x => x.id === item.id) >= 0))).shift();
      if (first) {
        setHistory(`/genres/${first.slug}/featured`)();
      }
    }
    else if (window.location.pathname === `/genres` && items && items.length > 0 && !isConnected) {
      const first = items[0];
      setHistory(`/genres/${first.slug}/featured`)();
    }
  }, [items, user, isConnected, setHistory])

  return (!items) ? null : (
    <>
      { (isConnected && user && user.genres && user.genres.length > 0) && <ListSection
        title={'Favorites'} 
        items={items.filter(hasFavorites)}
        style={style}
        isFavorite={true} 
        showIconFav={true}
        onClickFavoriteFunc={setMyGenres}
        isSelectedFunc={isSelected}
      /> }
      { Config.GENRES_HAS_FAV && <ListSection
        title={'Electronic'}
        className={'nofav'}
        items={items.filter(electronic)}
        style={style}
        isFavorite={false} 
        showIconFav={Config.GENRES_HAS_FAV}
        onClickFavoriteFunc={setMyGenres}
        isSelectedFunc={isSelected}
      /> }
      { Config.GENRES_HAS_FAV && <ListSection
        title={'Open Format'}
        className={'nofav'}
        items={items.filter(openFormat)}
        style={style}
        isFavorite={false} 
        showIconFav={Config.GENRES_HAS_FAV}
        onClickFavoriteFunc={setMyGenres}
        isSelectedFunc={isSelected}
      /> }
    </>
  )
}

ConnectedListSectionManager.propTypes = {
  items: PropTypes.any,
  style: PropTypes.object
}

const ListSectionManager = connect(
  state => ({
    api: state.api,
    user: state.user,
    isConnected: state.isConnected,
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setUser: user => dispatch(setUser(user))
  })
)(ConnectedListSectionManager);

export default ListSectionManager;
